export const jobPositionsCz = {
  jobCategories: {
    'Others': 'Ostatní',
    'administration': 'Administrativa',
    'automotive_industry': 'Automobilový průmysl',
    'other_manufacturing': 'Ostatní výrobní odvětví',
    'banking_leasing_insurance': 'Bankovnictví, leasing a pojišťovnictví',
    'civil_protection_security': 'Civilní ochrana a bezpečnost',
    'auxiliary_work_temp_jobs': 'Pomocné práce a brigády',
    'tourism_hospitality': 'Cestovní ruch, gastro, hotelnictví',
    'chemical_industry': 'Chemický průmysl',
    'transport_logistics': 'Spedice, doprava a logistika',
    'wood_processing': 'Dřevozpracující průmysl',
    'economics_finance_accounting': 'Ekonomika, finance, účetnictví',
    'electrical_engineering_energy': 'Elektrotechnika a energetika',
    'it_hardware': 'Informatika - hardware',
    'it_software': 'Informatika - software',
    'it_system_administration': 'Informatika - správa systémů',
    'human_resources': 'Lidské zdroje a personalistika',
    'quality_management': 'Management kvality',
    'marketing_advertising_pr': 'Marketing, reklama, PR',
    'sales': 'Obchod',
    'agriculture_forestry': 'Zemědělství a lesní hospodářství',
    'food_industry': 'Potravinářství',
    'law_legislation': 'Právo a legislativa',
    'translation_interpretation': 'Překladatelství a tlumočnictví',
    'education': 'Vzdělávání a školství',
    'services': 'Služby',
    'social_services': 'Sociální služby',
    'public_administration': 'Státní a veřejná správa',
    'real_estate_construction': 'Reality a stavebnictví',
    'engineering_technology': 'Strojírenství, technika a rozvoj',
    'telecommunications': 'Telekomunikace',
    'textile_clothing_industry': 'Textilní, kožedělný a oděvní průmysl',
    'art_culture': 'Umění a kultura',
    'science_research': 'Věda a výzkum',
    'environment_water_management': 'Životní prostředí a vodní hospodářství',
    'top_management': 'Vrcholový management',
    'production': 'Výroba',
    'customer_support': 'Zákaznická podpora',
    'healthcare_pharmacy': 'Zdravotnictví a farmacie',
    'media_journalism': 'Média a žurnalistika'
  },
  jobPositions: {
    'Others': 'Ostatní',
    'administrative_assistant': 'Administrativní pracovník',
    'online_store_administrator': 'Správce internetového obchodu',
    'archivist': 'Archivář',
    'assistant': 'Asistent',
    'office_manager': 'Office manažer',
    'car_wash_worker': 'Pracovník automyčky',
    'receptionist': 'Recepční',
    'officer': 'Referent',
    'sales_officer': 'Referent odbytu',
    'registry_management_officer': 'Referent správy registrů',
    'contract_management_officer': 'Referent správy smluv',
    'secretary': 'Sekretářka',
    'technical_administrative_worker': 'Technickoadministrativní pracovník',
    'phone_operator': 'Telefonní operátor',
    'car_upholsterer': 'Autočalouník',
    'auto_electrician': 'Autoelektrikář',
    'auto_body_repair_specialist': 'Autoklempíř',
    'automotive_designer': 'Autokonštruktér',
    'auto_mechanic': 'Automechanik',
    'auto_glass_technician': 'Autosklenář',
    'electromechanic': 'Elektromechanik',
    'maintenance_engineer': 'Inženýr údržby',
    'inspector': 'Kontrolor',
    'painter_lacquerer': 'Lakýrník',
    'production_operator': 'Operátor výroby',
    'tire_service_worker': 'Pracovník pneuservisu',
    'service_technician': 'Přijímací technik',
    'process_engineer': 'Procesní inženýr',
    'automotive_product_manager': 'Produktový manažer v automobilovém průmyslu',
    'automotive_project_manager': 'Projektový manažer v automobilovém průmyslu',
    'technologist': 'Technolog',
    'service_manager': 'Vedoucí servisu',
    'miner': 'Horník',
    'mining_technician': 'Důlní technik',
    'metallurgist': 'Hutník',
    'metallurgical_engineer': 'Hutní inženýr',
    'designer': 'Projektant',
    'account_manager': 'Account Manager',
    'back_office_specialist': 'Back office specialista',
    'compliance_specialist': 'Compliance specialista',
    'custody_specialist': 'Custody specialista',
    'dealer_trader': 'Dealer trader',
    'financial_analyst': 'Finanční analytik',
    'financial_controller': 'Finanční kontrolor',
    'financial_advisor': 'Finanční poradce',
    'mortgage_advisor': 'Hypoteční poradce',
    'investment_advisor': 'Investiční poradce',
    'client_advisor': 'Klientský poradce',
    'leasing_advisor': 'Leasingový poradce',
    'insurance_claim_appraiser': 'Likvidátor pojistných událostí',
    'insurance_liquidator': 'Pojistný likvidátor',
    'actuary': 'Pojistný matematik',
    'insurance_technician': 'Pojistný technik',
    'insurance_advisor': 'Pojišťovací poradce',
    'cashier': 'Pokladní',
    'treasury_payment_operations_worker': 'Pracovník treasury/platební styk',
    'teller': 'Přepážkový pracovník',
    'private_banker': 'Privátní bankéř',
    'product_manager': 'Produktový manažer',
    'project_manager': 'Projektový manažer',
    'payment_cards_officer': 'Referent platebních karet',
    'receivables_management_officer': 'Referent správy pohledávek',
    'insurance_management_officer': 'Referent správy pojištění',
    'premium_collection_officer': 'Referent výběru pojistného',
    'branch_manager': 'Ředitel pobočky',
    'risk_analyst': 'Risk analytik',
    'risk_manager': 'Risk manažer',
    'risk_specialist': 'Risk specialista',
    'insurance_payer_control_specialist': 'Specialista kontroly plátců pojistného',
    'underwriter': 'Underwriter/upisovatel pojistného rizika',
    'credit_officer': 'Úvěrový pracovník',
    'head_of_leasing_department': 'Vedoucí leasingového oddělení',
    'department_manager': 'Vedoucí oddělení',
    'security_manager': 'Bezpečnostní manažer',
    'security_technician': 'Bezpečnostní technik',
    'firefighter_rescuer': 'Hasič, záchranář',
    'security_service_manager': 'Manažer bezpečnostní služby',
    'police_officer': 'Policista',
    'fire_safety_technician': 'Požární technik',
    'security_service_worker': 'Pracovník bezpečnostní služby',
    'guard_service_worker': 'Pracovník ostrahy',
    'security_service_director': 'Ředitel bezpečnostní služby',
    'health_safety_technician': 'Technik BOZP',
    'fire_protection_technician': 'Technik požární ochrany',
    'prison_guard': 'Vězeňský dozorce',
    'soldier': 'Voják',
    'surveyor': 'Tazatel',
    'temporary_worker': 'Brigádník',
    'helper': 'Pomocný pracovník',
    'laborer': 'Dělník',
    'cleaner': 'Uklízečka',
    'porter': 'Vrátný',
    'leisure_animator': 'Animátor volného času',
    'barista': 'Barista',
    'bartender': 'Barman',
    'waiter': 'Číšník',
    'housekeeper': 'Pokojská',
    'concierge': 'Concierge',
    'confectioner': 'Cukrář',
    'f_b_manager': 'F&B manažer',
    'facility_manager': 'Facility manager',
    'front_desk_manager': 'Front desk manažer',
    'hostess': 'Hosteska',
    'croupier': 'Krupiér',
    'cook': 'Kuchař',
    'hotel_manager': 'Manažer hotelu',
    'hotel_pension_sales_department_manager': 'Manažer obchodního oddělení hotelu, penzionu',
    'butcher': 'Řezník',
    'baker': 'Pekař',
    'pizza_maker': 'Pizzař',
    'lifeguard': 'Plavčík',
    'kitchen_helper': 'Pomocná síla v kuchyni',
    'assistant_cook': 'Pomocný kuchař',
    'fast_food_worker': 'Pracovník rychlého občerstvení',
    'ticket_seller': 'Prodejce letenek',
    'travel_agent': 'Prodejce zájezdů',
    'operations_manager': 'Provozovatel',
    'chef': 'Šéfkuchař',
    'sommelier': 'Sommelier',
    'tourist_guide': 'Průvodce v cestovním ruchu',
    'steward_flight_attendant': 'Steward, letuška',
    'facility_operations_manager': 'Vedoucí provozu',
    'chemical_engineer': 'Chemický inženýr',
    'chemical_laboratory_technician': 'Chemický laborant',
    'chemist': 'Chemik',
    'chemical_industry_machinery_operator': 'Operátor strojů a zařízení v chemickém průmyslu',
    'chemical_industry_technologist': 'Technolog v chemickém průmyslu',
    'customs_declarant': 'Celní deklarant',
    'dispatcher': 'Dispečer',
    'scheduler': 'Disponent',
    'transportation_engineer': 'Dopravní inženýr',
    'shipping_clerk': 'Expedient',
    'ship_captain': 'Kapitán lodi',
    'logistics_transport_supply_controller': 'Kontrolor v logistice, dopravě a zásobování',
    'coordinator': 'Koordinátor',
    'courier': 'Kurýr',
    'logistician': 'Logistik',
    'logistics_manager': 'Manažer logistiky',
    'fleet_manager': 'Manažer vozového parku',
    'buyer': 'Nákupčí',
    'postal_carrier': 'Poštovní doručovatel',
    'shipping_worker': 'Pracovník lodní přepravy',
    'transport_project_manager': 'Projektový manažer v dopravě',
    'logistics_director': 'Ředitel logistiky',
    'train_driver': 'Strojvedoucí',
    'warehouse_worker': 'Skladník',
    'freight_forwarder': 'Speditér',
    'transport_manager': 'Vedoucí dopravy',
    'purchasing_manager': 'Vedoucí nákupu',
    'sales_department_manager': 'Vedoucí odbytu',
    'post_office_manager': 'Vedoucí pošty',
    'warehouse_manager': 'Vedoucí skladu',
    'bus_driver': 'Řidič autobusu',
    'truck_driver': 'Řidič kamionu',
    'public_transport_driver': 'Řidič MHD',
    'truck_driver_cargo': 'Řidič nákladního vozidla',
    'car_driver': 'Řidič osobního vozidla',
    'forklift_driver': 'Řidič vysokozdvižného vozíku',
    'stationmaster': 'Výpravčí',
    'train_dispatcher': 'Výpravčí',
    'supplier': 'Zásobovač',
    'delivery_driver': 'Rozvážeč',
    'upholsterer': 'Čalouník',
    'wood_engineer': 'Dřevařský inženýr',
    'wood_technician': 'Dřevařský technik',
    'furniture_designer': 'Konstruktér',
    'furniture_maker': 'Nábytkář',
    'sawyer': 'Pilař',
    'wood_processing_industry_designer': 'Projektant v dřevozpracujícím průmyslu',
    'carpenter': 'Truhlář',
    'audit_assistant': 'Asistent auditora',
    'auditor': 'Auditor',
    'broker': 'Broker',
    'tax_advisor': 'Daňový poradce',
    'economist': 'Ekonom',
    'invoice_clerk': 'Fakturant',
    'financial_agent': 'Finanční agent',
    'financial_manager': 'Finanční manažer',
    'chief_financial_officer': 'Finanční ředitel',
    'fundraiser': 'Fundraiser',
    'chief_accountant': 'Hlavní účetní',
    'mortgage_specialist': 'Hypoteční specialista',
    'consultant': 'Konzultant',
    'eu_projects_coordinator': 'Koordinátor EU projektů',
    'payroll_accountant': 'Mzdový účetní',
    'business_analyst': 'Obchodní analytik',
    'personal_banker': 'Osobní bankéř',
    'payment_operations_worker': 'Pracovník platebního styku',
    'settlement_officer': 'Referent zúčtování',
    'head_of_economic_department': 'Ředitel ekonomického úseku',
    'budget_planner_calculator': 'Rozpočtář, kalkulant',
    'invoicing_payments_specialist': 'Specialista fakturace a plateb',
    'financial_markets_specialist': 'Specialista finančních trhů',
    'receivables_specialist': 'Specialista pohledávek',
    'reporting_specialist': 'Specialista reportingu',
    'statistician': 'Statistik',
    'accountant': 'Účetní',
    'credit_specialist': 'Úvěrový specialista',
    'electrician': 'Elektrikář',
    'electrical_installer': 'Elektromontér',
    'electronics_technician': 'Elektronik',
    'electrical_engineer': 'Elektrotechnický inženýr',
    'electrical_technician': 'Elektrotechnik',
    'energy_specialist': 'Energetik',
    'simulation_engineer': 'Inženýr simulací',
    'integrated_circuit_designer': 'Konstruktér integrovaných obvodů',
    'aircraft_mechanic': 'Letecký mechanik',
    'refrigeration_equipment_mechanic': 'Mechanik chladicích zařízení',
    'mechatronics_specialist': 'Mechatronik',
    'energy_equipment_operator': 'Obsluha energetických zařízení',
    'repairman': 'Opravář',
    'lighting_technician': 'Osvětlovač',
    'electrical_engineering_project_manager': 'Projektový manažer v oblasti elektrotechniky',
    'energy_project_manager': 'Projektový manažer v oblasti energetiky',
    'inspection_technician': 'Revizní technik',
    'service_engineer': 'Servisní inženýr',
    'electrical_service_technician': 'Servisní technik',
    'test_technician': 'Zkušební technik',
    'network_strategy_specialist': 'Specialista strategie sítě',
    'system_engineer': 'Systémový inženýr',
    'technical_inspection_technician': 'Technik STK, EK',
    'technical_manager': 'Technický manažer',
    'technician': 'Technik',
    'sound_engineer': 'Zvukař',
    'telecommunications_network_designer': 'Návrhář telekomunikačních sítí',
    'computer_technician': 'Počítačový technik',
    'industrial_robot_programmer': 'Programátor průmyslových robotů',
    'transmission_network_analysis_development_specialist': 'Specialista analýz a rozvoje přenosových sítí',
    'abap_programmer': 'ABAP programátor',
    'android_programmer': 'Android programátor',
    'backend_developer': 'Back-end programátor',
    'business_intelligence_specialist': 'Business Intelligence Specialista',
    'c_programmer': 'C programátor',
    'crm_specialist': 'CRM specialista',
    'database_analyst': 'Databázový analytik',
    'database_specialist': 'Databázový specialista',
    'devops_engineer': 'DevOps Engineer',
    'front_end_programmer': 'Front-end programátor',
    'help_desk_worker': 'Help desk pracovník',
    'ios_programmer': 'iOS programátor',
    'it_analyst': 'IT analytik',
    'it_architect': 'IT architekt',
    'it_consultant': 'IT konzultant',
    'it_product_manager': 'IT produktový manažer',
    'it_project_manager': 'IT projektový manažer',
    'it_director': 'IT ředitel',
    'it_tester': 'IT tester',
    'java_programmer': 'Java programátor',
    'javascript_programmer': 'Javascript programátor',
    'net_programmer': '.NET programátor',
    'objective_c_programmer': 'Objective-C programátor',
    'oracle_programmer': 'Oracle programátor',
    'perl_programmer': 'Perl programátor',
    'php_programmer': 'PHP programátor',
    'plc_programmer': 'PLC programátor',
    'junior_programmer': 'Pomocný programátor',
    'sales_support_worker': 'Pracovník podpory prodeje',
    'programmer': 'Programátor',
    'python_programmer': 'Python programátor',
    'sap_product_manager': 'SAP Produktový Manažer',
    'sap_specialist': 'SAP Specialista',
    'scrum_master': 'Scrum Master',
    'software_engineer': 'Softwarový inženýr',
    'end_device_testing_specialist': 'Specialista testování koncových zařízení',
    'technical_writer': 'Technical writer',
    'user_experience_expert': 'User Experience Expert',
    'webmaster': 'Webmaster',
    'ict_specialist': 'ICT specialista',
    'it_technical_support_specialist': 'IT/Technical Support Specialista',
    'network_modeling_specialist': 'Specialista modelování sítí',
    'it_security_specialist': 'Specialista na IT bezpečnost',
    'fraud_prevention_specialist': 'Specialista prevence podvodů',
    'information_system_administrator': 'Správce informačního systému',
    'network_administrator': 'Správce počítačové sítě',
    'system_administrator': 'Systémový administrátor',
    'hr_assistant': 'HR asistent',
    'hr_business_partner': 'HR Business Partner',
    'hr_generalist': 'HR Generalista',
    'hr_coordinator': 'HR Koordinátor',
    'lecturer_trainer': 'Lektor, školitel',
    'human_resources_manager': 'Manažer lidských zdrojů',
    'hr_specialist': 'Personalista',
    'personnel_consultant': 'Personální konzultant',
    'personnel_manager': 'Personální manažer',
    'hr_director': 'Personální ředitel',
    'work_psychologist': 'Pracovní psycholog',
    'psychologist': 'Psycholog',
    'recruiter_selection_specialist': 'Recruiter, specialista výběrů',
    'head_of_hr_department': 'Ředitel personálního úseku',
    'compensation_specialist': 'Specialista pro odměňování',
    'training_education_specialist': 'Specialista pro vzdělávání a tréninky',
    'quality_inspector': 'Inspektor',
    'quality_engineer': 'Inženýr kvality',
    'quality_controller': 'Kontrolor kvality',
    'quality_manager': 'Manažer kvality',
    'quality_planner': 'Plánovač kvality',
    'quality_iso_director': 'Ředitel kvality a ISO',
    'iso_specialist': 'Specialista ISO',
    'brand_manager': 'Brand manager',
    'copywriter': 'Copywriter, reklamní textař',
    'dtp_operator': 'DTP operátor',
    'event_manager': 'Event manager',
    'graphic_designer': 'Grafický designér',
    'graphic_artist': 'Grafik',
    'spokesperson': 'Mluvčí',
    'complaints_department_manager': 'Manažer reklamačního oddělení',
    'marketing_manager': 'Marketingový manažer',
    'marketing_worker': 'Marketingový pracovník',
    'marketing_director': 'Marketingový ředitel',
    'marketing_specialist': 'Marketingový specialista',
    'multimedia_specialist': 'Multimedia Specialista',
    'ppc_specialist': 'PPC specialista',
    'pr_manager': 'PR manažer',
    'advertising_marketing_product_manager': 'Produktový manažer v oblasti reklamy a marketingu',
    'marketing_project_manager': 'Projektový manažer v marketingu',
    'market_research_project_manager': 'Projektový manažer v oblasti průzkumu trhu',
    'promoter': 'Promotér',
    'creative_director': 'Ředitel kreativity',
    'seo_analyst': 'SEO analytik',
    'internal_communication_specialist': 'Specialista interní komunikace',
    'marketing_analysis_specialist': 'Specialista marketingových analýz',
    'visual_merchandiser': 'Visual merchandiser / Vizualista',
    'relationship_manager': 'Vztahový manažer',
    'web_designer': 'Web designér',
    'inventory_commission_member': 'Člen inventurní komise',
    'country_manager_director': 'Country manager / director',
    'demand_planner': 'Demand planner',
    'merchandiser_stock_assistant': 'Merchandiser',
    'merchandiser': 'Merchandiser',
    'e_commerce_specialist': 'E-commerce specialista',
    'key_account_manager': 'Key account manager',
    'store_branch_manager': 'Manažer provozovny / pobočky',
    'salesperson': 'Obchodník, prodejce',
    'sales_manager': 'Obchodní manažer',
    'sales_representative_officer': 'Obchodní referent',
    'sales_director': 'Obchodní ředitel',
    'sales_representative': 'Obchodní zástupce',
    'specialist_salesperson': 'Odborný prodejce',
    'complaints_department_worker': 'Pracovník reklamačního oddělení',
    'pyrotechnics_seller': 'Prodejce pyrotechniky',
    'team_leader': 'Vedoucí směny',
    'shop_assistant': 'Prodavač',
    'retail_operations_manager': 'Provozní manažer',
    'regional_area_manager': 'Regionální / Oblastní manažer',
    'telemarketing_worker': 'Telemarketingový pracovník',
    'sales_team_manager': 'Vedoucí obchodní skupiny',
    'store_facility_manager': 'Vedoucí provozu, vedoucí prodejny',
    'complaints_department_head': 'Vedoucí reklamačního úseku',
    'store_section_manager': 'Vedoucí úseku prodejny',
    'deputy_store_facility_manager': 'Zástupce vedoucího prodejny/provozovny',
    'agronomist': 'Agronom',
    'animal_breeder_caretaker': 'Chovatel, ošetřovatel zvířat',
    'milker': 'Dojička',
    'forester': 'Lesník',
    'forest_engineer': 'Lesní inženýr',
    'forest_technician': 'Lesní technik',
    'soil_scientist': 'Půdoznalec',
    'agricultural_engineer_agronomist': 'Zemědělský inženýr, agronom',
    'agricultural_technician': 'Zemědělský technik',
    'agricultural_technologist': 'Zemědělský technolog',
    'cooperative_chairman': 'Předseda družstva',
    'farmer': 'Farmář',
    'tractor_combine_operator': 'Traktorista, kombajnér',
    'veterinary_assistant': 'Veterinární asistent',
    'veterinarian': 'Veterinární lékař',
    'gardener': 'Zahradník',
    'landscape_architect': 'Zahradní architekt',
    'picker': 'Sběrač',
    'zootechnician': 'Zootechnik',
    'food_engineer': 'Potravinářský inženýr',
    'food_technician': 'Potravinářský technik',
    'food_technologist': 'Potravinářský technolog',
    'trainee_lawyer': 'Advokátní koncipient',
    'bailiff': 'Exekutor',
    'bailiff_trainee': 'Exekutorský koncipient',
    'registrar': 'Matrikář',
    'notary': 'Notář',
    'notary_trainee': 'Notářský koncipient',
    'paralegal_law_student': 'Paralegal – student práva',
    'lawyer': 'Právník',
    'legal_assistant': 'Právní asistent',
    'regulatory_affairs_manager': 'Regulatory affairs manager',
    'regulatory_affairs_specialist': 'Regulatory affairs specialist',
    'enforcement_specialist': 'Specialista zajištění',
    'judge': 'Soudce',
    'court_expert': 'Soudní znalec',
    'head_of_legal_department': 'Vedoucí právního oddělení',
    'proofreader': 'Korektor',
    'translation_agency_business_manager': 'Obchodní manažer překladatelské agentury',
    'translator': 'Překladatel',
    'interpreter': 'Tlumočník',
    'teaching_assistant': 'Asistent učitele',
    'phd_student': 'Doktorand',
    'driving_instructor': 'Instruktor autoškoly',
    'speech_therapist': 'Logoped',
    'vocational_education_master': 'Mistr odborné výchovy',
    'professor': 'Profesor',
    'school_principal': 'Ředitel školy',
    'school_caretaker': 'Školník',
    'social_worker': 'Sociální pracovník',
    'special_education_teacher': 'Speciální pedagog',
    'sports_coach': 'Sportovní trenér',
    'primary_school_teacher_grades_1_4': 'Učitel 1.stupně ZŠ',
    'primary_school_teacher_grades_5_9': 'Učitel 2.stupně ZŠ',
    'secondary_school_teacher': 'Učitel na střední škole',
    'university_teacher': 'Učitel na vysoké škole',
    'kindergarten_teacher': 'Učitelka v mateřské škole',
    'educator': 'Vychovatelka',
    'florist_decorator': 'Aranžér',
    'au_pair': 'Au-pair',
    'coach': 'Kouč',
    'photographer': 'Fotograf',
    'house_keeper': 'Hospodyně',
    'watchmaker': 'Hodinář',
    'houseman': 'Houseman',
    'plumber': 'Instalatér',
    'interior_designer': 'Interiérový návrhář',
    'hairdresser': 'Kadeřník, kadeřnice',
    'fitness_trainer': 'Kondiční trenér',
    'blacksmith': 'Kovář',
    'beautician': 'Kosmetička',
    'stoker': 'Topič',
    'florist': 'Květinář',
    'painter': 'Malíř, natěrač',
    'gas_station_attendant': 'Obsluha čerpací stanice',
    'wedding_planner': 'Organizátor svateb',
    'pedicurist_manicurist': 'Pedikérka, manikérka',
    'stylist_makeup_artist': 'Stylista, vizážista',
    'maintenance_worker': 'Údržbář',
    'goldsmith_jeweler': 'Zlatník, klenotník',
    'caregiver': 'Pečovatelka',
    'professional_parent': 'Profesionální rodič',
    'customs_officer': 'Celník',
    'general_state_advisor': 'Generální státní rada',
    'chief_advisor': 'Hlavní rada',
    'chief_officer': 'Hlavní referent',
    'chief_state_advisor': 'Hlavní státní rada',
    'expert_advisor': 'Odborný rada',
    'expert_officer': 'Odborný referent',
    'advisor': 'Rada',
    'department_director': 'Ředitel odboru',
    'independent_advisor': 'Samostatný rada',
    'independent_officer': 'Samostatný referent',
    'public_procurement_specialist': 'Specialista veřejných zakázek',
    'professional_soldier': 'Voják z povolání',
    'state_administration_employee': 'Zaměstnanec státní správy',
    'public_administration_employee': 'Zaměstnanec veřejné správy',
    'architect': 'Architekt',
    'interior_architect': 'Bytový architekt',
    'geologist': 'Geolog',
    'insulation_worker': 'Izolatér',
    'tinsmith_roofer': 'Klempíř, pokrývač',
    'scaffolder': 'Lešenář',
    'installer': 'Montážník',
    'mason_tiler': 'Zedník, obkladač',
    'real_estate_appraiser': 'Odhadce nemovitostí',
    'window_installer_glazier': 'Sklenář',
    'construction_machinery_operator': 'Operátor stavebních strojů',
    'floor_layer_paver': 'Podlahář, dlažebník',
    'pipe_fitter': 'Potrubář',
    'hvac_worker': 'Pracovník vzduchotechniky a klimatizace',
    'industrial_climber': 'Průmyslový horolezec',
    'construction_planner': 'Přípravář staveb',
    'mep_designer': 'Projektant TZB',
    'construction_project_manager': 'Projektový manažer ve stavebnictví',
    'real_estate_agent': 'Realitní makléř',
    'construction_estimator': 'Rozpočtář/kalkulant staveb',
    'drywall_installer': 'Sádrokartonář',
    'building_manager': 'Správce budov',
    'structural_engineer': 'Statik',
    'construction_supervisor': 'Stavbyvedoucí',
    'civil_engineer': 'Stavební inženýr',
    'construction_foreman': 'Stavební mistr',
    'construction_technician': 'Stavební technik',
    'construction_locksmith': 'Stavební zámečník',
    'construction_carpenter': 'Tesař',
    'locksmith': 'Zámečník',
    'land_surveyor': 'Zeměměřič',
    'crane_operator': 'Jeřábník',
    'welder': 'Svářeč',
    'grinder': 'Brusič',
    'cad_designer': 'CAD návrhář',
    'cnc_programmer': 'CNC programátor',
    'milling_machine_operator_turner': 'Frézař, soustružník',
    'metal_worker': 'Obráběč kovů',
    'engineering_machinery_operator': 'Operátor strojů a zařízení ve strojírenství',
    'process_manager': 'Procesní manažer',
    'engineering_project_manager': 'Projektový manažer ve strojírenství',
    'machinist': 'Strojník',
    'mechanical_engineer': 'Strojní inženýr',
    'mechanical_technician': 'Strojní technik',
    'mechanical_locksmith': 'Strojní zámečník',
    'technical_worker': 'Technický pracovník',
    'technical_process_engineer': 'Technický procesní inženýr',
    'technical_designer': 'Technický projektant',
    'technical_project_manager': 'Technický projektový manažer',
    'technical_director': 'Technický ředitel',
    'non_destructive_testing_technician': 'Technik nedestruktivních zkoušek',
    'head_of_technical_department': 'Vedoucí technického oddělení',
    'call_center_manager': 'Manažer call centra',
    'is_product_manager': 'Produktový manažer IS',
    'telecommunications_project_manager': 'Projektový manažer v telekomunikacích',
    'call_center_director': 'Ředitel call centra',
    'oss_bss_specialist': 'Specialista OSS/BSS',
    'radio_network_planning_specialist': 'Specialista plánování rádiové sítě',
    'network_services_operations_specialist': 'Specialista provozu sítí a služeb',
    'radio_network_optimization_specialist': 'Specialista optimalizace rádiové sítě',
    'mobile_network_development_specialist': 'Specialista rozvoje mobilní sítě',
    'communication_systems_specialist': 'Specialista spojovacích systémů',
    'telecommunications_product_development_specialist': 'Specialista vývoje telekomunikačních produktů',
    'telecommunications_services_development_specialist': 'Specialista vývoje telekomunikačních služeb',
    'call_center_supervisor': 'Supervizor call centra',
    'telecommunications_technical_worker': 'Technický pracovník v telekomunikacích',
    'customer_service': 'Zákaznický servis',
    'furrier': 'Kožešník',
    'tailor_seamstress': 'Krejčí, švadlena',
    'shoemaker': 'Obuvník',
    'fashion_designer': 'Oděvní návrhář',
    'clothing_industry_machinery_operator': 'Operátor strojů a zařízení v oděvním průmyslu',
    'cutter': 'Střihač',
    'creative_designer': 'Designér',
    'cameraman_editor': 'Kameraman, střihač',
    'cultural_officer': 'Kulturní referent',
    'makeup_artist_wig_maker': 'Maskér, vlásenkář',
    'fashion_stylist': 'Módní návrhář',
    'set_designer': 'Scénograf',
    'singer_actor_musician': 'Zpěvák, herec, hudebník',
    'dancer_choreographer': 'Tanečník, choreograf',
    'art_designer': 'Umělecký designér',
    'art_photographer': 'Umělecký fotograf',
    'art_painter': 'Umělecký malíř',
    'cultural_institution_employee': 'Zaměstnanec kulturní instituce',
    'biologist': 'Biolog',
    'research_chemist': 'Chemik',
    'physicist': 'Fyzik',
    'librarian': 'Knihovník',
    'laboratory_technician': 'Laborant',
    'metrologist': 'Metrolog',
    'microbiologist': 'Mikrobiolog',
    'sociologist': 'Sociolog',
    'research_scientific_worker': 'Výzkumný a vědecký pracovník',
    'ecologist_environmentalist': 'Ekolog, environmentalista',
    'environmentalist': 'Environmentalista',
    'geodesist': 'Geodet',
    'water_management_engineer': 'Vodohospodářský inženýr',
    'water_management_technician': 'Vodohospodářský technik',
    'country_director_manager': 'Country director, manager',
    'ceo': 'Generální ředitel',
    'executive_director': 'Výkonný ředitel',
    'packer': 'Balič',
    'production_foreman': 'Mistr výroby',
    'assembler': 'Montážník, montér',
    'cnc_machine_setter': 'Seřizovač CNC strojů',
    'machine_setter': 'Seřizovač strojů',
    'tool_maker': 'Nástrojař',
    'work_standards_specialist': 'Normovač práce',
    'machine_operator': 'Operátor strojů a zařízení',
    'production_planner': 'Plánovač výroby',
    'maintenance_manager': 'Vedoucí údržby',
    'production_director': 'Výrobní ředitel',
    'foundry_worker': 'Slévač',
    'client_service_worker': 'Klientský pracovník',
    'customer_service_manager': 'Manažer zákaznického servisu',
    'help_desk_support_worker': 'Pracovník help desku',
    'customer_support_specialist': 'Specialista podpory zákazníků',
    'nutrition_assistant': 'Asistent výživy',
    'dental_hygienist': 'Dentální hygienistka',
    'home_caregiver': 'Domácí pečovatelka',
    'drug_safety_specialist': 'Drug Safety Specialist',
    'pharmacist': 'Farmaceut',
    'pharmaceutical_laboratory_technician': 'Farmaceutický laborant',
    'physiotherapist': 'Fyzioterapeut',
    'head_nurse': 'Hlavní sestra',
    'hygienist': 'Hygienik',
    'laboratory_diagnostician': 'Laboratorní diagnostik',
    'doctor': 'Lékař',
    'masseur': 'Masér',
    'medical_advisor': 'Medical advisor',
    'medical_pharmaceutical_representative': 'Lékařský/farmaceutický reprezentant',
    'clinical_trial_monitor': 'Monitor klinických studií',
    'optician': 'Oční optik',
    'optometrist': 'Optometrista',
    'orthopedic_technician': 'Ortopedický technik',
    'midwife': 'Porodní asistentka',
    'healthcare_product_manager': 'Produktový manažer v oblasti zdravotnictví',
    'healthcare_project_manager': 'Projektový manažer v oblasti zdravotnictví',
    'radiologist': 'Radiolog',
    'radiology_assistant': 'Radiologický asistent',
    'audit_nurse': 'Revizní sestra',
    'audit_pharmacist': 'Revizní farmaceut',
    'audit_doctor': 'Revizní lékař',
    'healthcare_facility_director': 'Ředitel zdravotnického zařízení',
    'orderly': 'Sanitář',
    'nurse': 'Sestra',
    'medicine_warehouse_worker': 'Skladník léčiv',
    'healthcare_purchasing_specialist': 'Specialista nákupu zdravotní péče',
    'health_program_development_specialist': 'Specialista vývoje programů zdraví',
    'support_health_activities_specialist': 'Specialista podpůrných a zdravotních činností',
    'public_health_specialist': 'Veřejný zdravotník',
    'senior_nurse': 'Vrchní sestra',
    'registered_nurse': 'Zdravotní sestra',
    'medical_laboratory_technician': 'Zdravotnický laborant',
    'paramedic': 'Zdravotnický záchranář',
    'healthcare_assistant': 'Zdravotní asistent',
    'dental_assistant': 'Zubní asistent',
    'dental_laboratory_technician': 'Zubní laborant',
    'dentist': 'Zubní lékař',
    'dental_technician': 'Zubní technik',
    'editor': 'Editor',
    'editor_in_chief': 'Hlavní redaktor',
    'bookbinder': 'Knihař',
    'advertising_manager': 'Manažer inzerce',
    'media_buyer': 'Media buyer',
    'media_planner': 'Media planner',
    'journalist': 'Novinář',
    'producer': 'Produkční',
    'production_manager': 'Produkční manažer',
    'editorial_writer': 'Redaktor',
    'publishing_director': 'Ředitel vydavatelství',
    'chief_editor': 'Šéfredaktor',
    'social_media_specialist': 'Social media specialista',
    'printer': 'Tiskař',
    'deputy_editor': 'Zástupce redaktora'
  }
};